import ESTIMATE_CONSTANT from "../../constant/estimateConstant"

const isRoHS = (value: string) => {
  switch (value) {
    case ESTIMATE_CONSTANT.表面処理["水溶性フラックス(リジッド)"].value:
    case ESTIMATE_CONSTANT.表面処理["端子部のみ電解金めっき＋水溶性フラックス"].value:
    case ESTIMATE_CONSTANT.表面処理["無鉛はんだレベラー(リジッド)"].value:
    case ESTIMATE_CONSTANT.表面処理["端子部のみ電解金めっき＋無鉛はんだレベラー"].value:
    case ESTIMATE_CONSTANT.表面処理["無電解金フラッシュ(リジッド)"].value:
    case ESTIMATE_CONSTANT.表面処理.リード無し電解金めっき.value:
    case ESTIMATE_CONSTANT.表面処理.ワイヤーボンディング向け無電解ニッケルパラジウム金めっき.value:
    case ESTIMATE_CONSTANT.表面処理.ワイヤーボンディング向け無電解ニッケル金めっき.value:
    case ESTIMATE_CONSTANT.表面処理["しない（銅箔のみ）(リジッド)"].value:

    case ESTIMATE_CONSTANT.表面処理["無電解金フラッシュ(フレキシブル)"].value:
    case ESTIMATE_CONSTANT.表面処理.錫めっき.value:
    case ESTIMATE_CONSTANT.表面処理["しない（銅箔のみ）(フレキシブル)"].value:
    case ESTIMATE_CONSTANT.表面処理["電解金めっき＋水溶性フラックス"].value:

    case ESTIMATE_CONSTANT.表面処理["水溶性フラックス(メタル)"].value:
    case ESTIMATE_CONSTANT.表面処理["無鉛はんだレベラー(メタル)"].value:
    case ESTIMATE_CONSTANT.表面処理["無電解金フラッシュ(メタル)"].value:
    case ESTIMATE_CONSTANT.表面処理.ニッケルパラジウム金めっき.value:
    case ESTIMATE_CONSTANT.表面処理.ワイヤーボンディング向け金めっき.value:
      return true

    default:
      return false
  }
}

export default isRoHS
